import { useSyncExternalStore } from "react";

let snapshot = { key: null, range: null };
const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

export function getTableSelection() {
  return snapshot;
}

export function setTableSelection(next) {
  const key = next?.key ?? null;
  const range = next?.range ?? null;
  if (snapshot.key === key && snapshot.range === range) return;
  snapshot = { key, range };
  emit();
}

export function useTableSelection() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    getTableSelection,
    getTableSelection,
  );
}

// Which font fields differ across the cells a table's toolbar change would hit. Live state only: it is never
// written into the design, so the toolbar can show "mixed" without saving a made-up value.
let mixedByTable = {};
const mixedListeners = new Set();

export function getTableMixed() {
  return mixedByTable;
}

export function setTableMixed(key, flags) {
  const next = flags && (flags.fontSize || flags.fontFamily) ? { fontSize: !!flags.fontSize, fontFamily: !!flags.fontFamily } : null;
  const current = mixedByTable[key] || null;
  if (current?.fontSize === next?.fontSize && current?.fontFamily === next?.fontFamily) return;
  const copy = { ...mixedByTable };
  if (next) copy[key] = next;
  else delete copy[key];
  mixedByTable = copy;
  mixedListeners.forEach((listener) => listener());
}

export function useTableMixed() {
  return useSyncExternalStore(
    (listener) => {
      mixedListeners.add(listener);
      return () => mixedListeners.delete(listener);
    },
    getTableMixed,
    getTableMixed,
  );
}
